import { createTrackerForCategory } from '@gonfalon/analytics/createTrackerForCategory';

const trackAnnouncement = createTrackerForCategory('Announcement');

export const trackAnnouncementShown = (key: string) => trackAnnouncement('Announcement Shown', { key });

export const trackAnnouncementCtaClicked = (key: string) => trackAnnouncement('Announcement CTA Clicked', { key });

export const trackAnnouncementCommandCopied = (key: string) =>
  trackAnnouncement('Announcement Command Copied', { key });
